import BaseController from "./BaseController";
import JSONModel from "sap/ui/model/json/JSONModel";

/**
 * @namespace computec.b2b.portal.controller
 */
export default class AuthError extends BaseController {
	public onInit(): void {
		this.getView().setModel(new JSONModel({ detail: "" }), "view");
		this.getRouter().getRoute("authError")?.attachPatternMatched(() => { this.onShow(); });
	}

	private onShow(): void {
		const stash = window.sessionStorage.getItem("portal.authError.detail");
		const detail = stash ?? "";
		(this.getView().getModel("view") as JSONModel).setProperty("/detail", detail);
	}

	public onRetry(): void {
		window.sessionStorage.removeItem("portal.authError.detail");
		window.location.assign(window.location.pathname);
	}

	public async onSignOut(): Promise<void> {
		window.sessionStorage.removeItem("portal.authError.detail");
		const oidc = this.getOwnerComponent().getOidc();
		if (!oidc) {
			window.location.assign(window.location.pathname);
			return;
		}
		await oidc.logout();
	}
}
